<script>
import { usePermissions } from '@/composables/usePermissions';

export default {
  props: {
    tncFilesList: {
      type: Object,
      required: true,
    },
  },
    setup() {
        const {
            canReadInternalUser,
            permissions,
            canDeleteTnc,
            canCreateTnc,
            canUpdateTnc,
            canExportTnc,
            canReadTnc,
        } = usePermissions()
        return {
            canReadInternalUser,
            permissions,
            canDeleteTnc,
            canCreateTnc,
            canUpdateTnc,
            canExportTnc,
            canReadTnc
        };
    },
  methods: {
    handleFileUpload(event) {
      this.$emit('upload-tnc', event.target.files[0]);
    },
    handleUpdateFile(event, item) {
      const file = event.target.files[0];
      this.$emit('update-tnc', { file, item });
    },
    handleDeleteFile(item) {
      this.$emit('delete-tnc', item);
    },
    handlePreviewFile(item) {
      this.$emit('preview-tnc', item)
    },
  },
}
</script>
<template>
  <div class="container-fluid p-0">
    <div class="row" >
      <div class="col-12">
        <div v-if="canCreateTnc" class="d-flex justify-content-end mb-3">
          <label for="fileUpload" class="btn btn-primary">
            <i  class="ri-upload-2-line align-middle me-1"></i> Upload T&C
            <input type="file" id="fileUpload" @change="handleFileUpload" class="d-none" accept=".pdf,application/pdf">
          </label>
        </div>
        <div class="card">
          <div class="card-body" v-if="canReadTnc">
            <div class="live-preview">
              <div v-if='loadingRoles' class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else class="table-responsive">
                <table class="table table-striped table-nowrap mb-0">
                  <thead class="table-secondary">
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Created Date</th>
                      <th>Created By</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in tncFilesList" :key="index" class="content">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.created_at }}</td>
                      <td>{{ item.created_by }}</td>
                      <td>
                        <i @click="handlePreviewFile(item)" class="ri-eye-fill" style="cursor: pointer;"></i>
                        &nbsp;
                        <label :for="'fileInputUpdate' + item.id" class="bx bx-wrench" style="cursor: pointer;"></label>
                        <input v-if="canUpdateTnc" :id="'fileInputUpdate' + item.id" type="file"  @change="handleUpdateFile($event, item)"
                          class="d-none" accept=".pdf,application/pdf">
                        &nbsp;
                        <i v-if="canDeleteTnc" @click="handleDeleteFile(item)" class="ri-delete-bin-5-fill" style="cursor: pointer;"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>